import { Box, IconButton, Typography } from '@mui/material';
import Dropzone from 'react-dropzone';

import Close from '@mui/icons-material/Close';
import UploadFileIcon from '@assets/images/uploadFileIcon.svg';

function bytesToMegabytes(bytes) {
  const megabytes = bytes / (1024 * 1024);
  return megabytes;
}

const UploadedFileUI = ({ file, setFile }) => {
  return (
    <Box display="flex" flexDirection="column" gap="6px">
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        padding="8px 20px"
        border="1px solid var(--blue-gradient-03)"
        borderRadius="200px"
        width="fit-content"
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography color="var(--blue-gradient-03)" variant="body2">
            {file?.name}
          </Typography>
          <Typography color="var(--neutral-800)">
            ({bytesToMegabytes(file?.size).toFixed(2)} MB)
          </Typography>
        </Box>
        <IconButton sx={{ padding: '2px' }} onClick={() => setFile(null)}>
          <Close
            sx={{
              width: '18px',
              height: '18px',
              color: 'var(--blue-gradient-03)',
            }}
          />
        </IconButton>
      </Box>
      <Typography variant="body2" color="var(--neutral-900)">
        ※ 업로드 파일을 변경하려면 [X] 버튼을 눌러 파일을 삭제 후 변경할 파일을
        선택합니다.
      </Typography>
    </Box>
  );
};

const UploadFileUI = ({ setFile }) => {
  return (
    <Dropzone onDrop={(acceptedFiles) => setFile(acceptedFiles[0])}>
      {({ getRootProps, getInputProps }) => (
        <Box
          sx={{
            cursor: 'pointer',
          }}
          width="360px"
          border="1px dashed var(--neutral-700)"
          borderRadius="4px"
          display="flex"
          flexDirection="column"
          gap={3}
          alignItems="center"
          padding="24px"
          {...getRootProps()}
        >
          <Box>
            <img
              src={UploadFileIcon}
              alt="upload file"
              width={38}
              height={41}
            />
          </Box>
          <Typography variant="body2" color="var(--gray-700)">
            Drop your file here or{' '}
            <Typography
              color="var(--blue-gradient-03)"
              variant="caption"
              fontSize="14px"
              lineHeight="20px"
              fontWeight={400}
            >
              browse
            </Typography>
            <input {...getInputProps()} />
          </Typography>
        </Box>
      )}
    </Dropzone>
  );
};

const UploadFile = ({ uploadedFile, setUploadedFile }) => {
  return uploadedFile ? (
    <UploadedFileUI file={uploadedFile} setFile={setUploadedFile} />
  ) : (
    <UploadFileUI setFile={setUploadedFile} />
  );
};

export default UploadFile;
